import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SelectionStateManagerPEP.html?raw';
import "../../../moreCore/UI/SelectBox/SelectBox";
import "../../../moreCore/UI/Button/Button";

import "../../SharedTypes/mixed";


class StackEntry {
    Entity: DataItem_Content;
    action: "create" | "delete";
}

interface Config {
    commitAPI: string;
}

class SelectionStateManagerPEP extends compose(_WidgetBaseSP) {
    templateString: any = template;

    stack: Array<StackEntry> = new Array<StackEntry>();

    private _config: Config;

    itemsToDelete: Array<DataItem_Content> = new Array<DataItem_Content>();
    itemsToCreate: Array<DataItem_Content> = new Array<DataItem_Content>();

    deletedNode: HTMLDivElement;
    createdNode: HTMLDivElement;
    btnCommit: HTMLButtonElement;
    btnRollback: HTMLButtonElement;

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.displayStack();
    }

    setup(config: Config) {
        this._config = config;
    }

    displayStack(): void {
        this._calculateStackEntityActions();

        this.UiModder.domAttr.set(this.deletedNode, "innerHTML", this.itemsToDelete.length + this.getTranslation("OM_Matrix__lbl_ItemsDeleted"));
        this.UiModder.domAttr.set(this.createdNode, "innerHTML", this.itemsToCreate.length + this.getTranslation("OM_Matrix__lbl_ItemsCreated"));

        if (this.itemsToCreate.length > 0 || this.itemsToDelete.length > 0) {
            this.UiModder.domClass.remove(this.btnCommit, "w3-disabled");
            this.UiModder.domClass.remove(this.btnRollback, "w3-disabled");

            //this.btnCommit.setReadonly(false);
            //this.btnRollback.setReadonly(false);
        } else {
            //this.btnCommit.setReadonly(true);
            //this.btnRollback.setReadonly(true);
            this.UiModder.domClass.add(this.btnCommit, "w3-disabled");
            this.UiModder.domClass.add(this.btnRollback, "w3-disabled");
        }
    }

    ClearStack(): void {
        this.stack = new Array<StackEntry>();
        this.displayStack();
    }

    addToStack(entity: DataItem_Content, action: "create" | "delete"): void {
        let entry = new StackEntry();
        entry.Entity = entity;
        entry.action = action;
        this.stack.push(entry)

        this.displayStack();
    }

    _onClick_Rollback(): void {
        this.emit("rollback");
    }

    _onClick_Commit(): void {
        this.Commit();
    }

    _calculateStackEntityActions(): void {
        this.itemsToCreate = new Array<DataItem_Content>();
        this.itemsToDelete = new Array<DataItem_Content>();

        for (let stackEntry of this.stack) {
            if (stackEntry.action == "create") {
                this.itemsToCreate.push(stackEntry.Entity);
            } else if (stackEntry.action == "delete") {
                if (stackEntry.Entity.ID != null) {
                    this.itemsToDelete.push(stackEntry.Entity);
                }

                let deletedIndexInCreateArray = this.itemsToCreate.indexOf(stackEntry.Entity);
                if (deletedIndexInCreateArray > -1) {
                    this.itemsToCreate.splice(deletedIndexInCreateArray, 1); // ungespeichertes item in create-liste das gelöscht werden soll oO
                }
            }
        }
    }

    Commit(): void {

        //  delete und create-Listen befüllen
        //
        this._calculateStackEntityActions();

        this.emit("beforeCommit", true);

        //  gesamten Stack in einem Request verarbeiten
        //
       /* let url = window.appRoot + "data/CommitContent";
        this.RequestManager.post(url,
            {
                "JsonData": JSON.stringify({
                    "itemsToDelete": this.itemsToDelete,
                    "itemsToCreate": this.itemsToCreate
                })
            },
            lang.hitch(this, this.handleStack_Response),
            lang.hitch(this, this.handleStack_Error)
        );*/

        this.RequestManager.callfunction(
            this._config.commitAPI,
            {
                "itemsToDelete": this.itemsToDelete,
                "itemsToCreate": this.itemsToCreate
            },
            lang.hitch(this, this.handleStack_Response),
            lang.hitch(this, this.handleStack_Error)
        );
    }

    handleStack_Response(response: any): void {
        this.emit("commit", true);
    }

    handleStack_Error(error: any): void {
        this.emit("commit", false);
    }


    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(SelectionStateManagerPEP);